import Title from 'antd/lib/skeleton/Title';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const centerContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  textAlign: 'center',
};

function Confirmation() {

  const navigate = useNavigate();

  return (
    <div className="container" style={centerContentStyle}>
      <div>
        <div>
          <div>
            <h1
            className='mb-2'
            style={
                {
                    fontSize: '3rem',
                    fontWeight: 'bold',
                }
            }

            >Thank you for your submission</h1>
            <p
            className='mb-2'
            style={
                {
                    fontSize: '1.5rem',
                }
            }
            >
              A confirmation email has been sent to the email address you provided.
            </p>
            <button
                className="mt-4 btn btn-primary"
                onClick={() => {
                    navigate('/Login');
                }}
            >
                Submit a new form
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Confirmation;
